import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Button, Col } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import moment from 'moment'
import AntdTable from '@/components/table/AntdTable'
import { formatMessage, paginationInit, dateTrans, downLoadFileBlob } from '@/utils/common'
// import { getNFCSKUHistoryList } from '@/services/configuration/config'
import {
  getAPILogList,
  getAPILogListWms,
  getAPITaskRetry,
  dashboardPayloadDownload
} from '@/services/dashboard/dashboard'
import { messageModal } from '@/utils/modalUtils'
import SearchBar from '@/components/searchbar/SearchBar'
import { configQuery } from '@/services/configuration/config'
import { hasPermission } from '@/annotations/nike-react'
import { SYSTEM_LIST } from '@/utils/types'
const dateFormat = 'YYYY-MM-DD'
const menu_nfc_apiDashboard = 'menu_nfc_apiDashboard'
// const dateFormat2 = 'YYYY-MM-DD HH:mm:ss'
const startMonth = dayjs()
  .subtract(1, 'months')
  .add(1, 'day')
const endMonth = dayjs()

const NfcSkuModalTable = props => {
  let lastTableListId = useRef([])
  let isResendLastFlag =
    props.apiType === 'NFC_SKU_LIST_TO_1025' ||
    props.apiType === 'NFC_SKU_LIST_TO_1027' ||
    props.apiType === 'NFC_SKU_LIST_TO_LX'
  let isResendFlag = props.apiType === 'NFC_SKU_LIST_TO_WMS'
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.nfcUIDReport.plant',
      key: 'plant',
      initialValues: props.plantCodeList || [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.nfcUIDReport.sendStatus',
      key: 'sendStatus',
      initialValues: props.failCount > 0 ? 'FAIL' : '',
      selectAllClear: true,
      selectList: [
        { value: 'SUCCESS', label: 'Success' },
        { value: 'FAIL', label: 'Fail' }
      ],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.nfcUIDReport.taggingDate',
      key: 'taggingDate',
      format: dateFormat,
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      initialValues: props.failCount > 0 ? [] : [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  if (isResendFlag) {
    searchListInit = [
      {
        type: 'select',
        label: 'languageObj.nfcUIDReport.system',
        key: 'plant',
        initialValues: props.plantCodeList || [],
        mode: 'multiple',
        maxTagCount: 1,
        selectList: SYSTEM_LIST,
        spans: {
          xl: 8,
          xxl: 8
        }
      },
      {
        type: 'select',
        label: 'languageObj.nfcUIDReport.sendStatus',
        key: 'sendStatus',
        initialValues: props.failCount > 0 ? 'FAIL' : '',
        selectAllClear: true,
        selectList: [
          { value: 'SUCCESS', label: 'Success' },
          { value: 'FAIL', label: 'Fail' }
        ],
        spans: {
          xl: 8,
          xxl: 8
        }
      },
      {
        type: 'timeRange',
        label: 'languageObj.nfcUIDReport.taggingDate',
        key: 'taggingDate',
        format: dateFormat,
        disabledDate: current => {
          let falg =
            (current &&
              current <
                moment()
                  .subtract(1, 'year')
                  .subtract(1, 'day')) ||
            (current && current > moment().endOf('day'))
          return falg
        },
        initialValues: props.failCount > 0 ? [] : [startMonth, endMonth],
        spans: {
          xl: 8,
          xxl: 8
        }
      }
    ]
  }
  if (isResendLastFlag) {
    searchListInit = [
      {
        type: 'select',
        label: 'languageObj.nfcUIDReport.sendStatus',
        key: 'sendStatus',
        initialValues: props.failCount > 0 ? 'FAIL' : '',
        selectAllClear: true,
        selectList: [
          { value: 'SUCCESS', label: 'Success' },
          { value: 'FAIL', label: 'Fail' }
        ],
        spans: {
          xl: 8,
          xxl: 8
        }
      },
      {
        type: 'timeRange',
        label: 'languageObj.nfcUIDReport.sendDate',
        key: 'taggingDate',
        format: dateFormat,
        disabledDate: current => {
          let falg =
            (current &&
              current <
                moment()
                  .subtract(1, 'year')
                  .subtract(1, 'day')) ||
            (current && current > moment().endOf('day'))
          return falg
        },
        initialValues: props.failCount > 0 ? [] : [startMonth, endMonth],
        spans: {
          xl: 8,
          xxl: 8
        }
      }
    ]
  }

  const commonStore = useSelector(state => state.commonStore)
  const [pagination, setPagination] = useState(paginationInit)
  const [tableList, setTableList] = useState([])
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  let formRef = useRef(null)

  useEffect(() => {
    searchPlant()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getTableList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  // const searchClearDataBtn = () => {
  //   formRef && formRef.current.clearForm()
  //   const pg = {
  //     ...pagination,
  //     currentPage: 1
  //   }
  //   setPagination(pg)
  //   setQueryFlag(!queryFlag)
  // }
  const searchPlant = () => {
    let num = 99999999
    const params = {
      configKey: 'plant_code',
      // configStatus: true,
      configType: 'plant_code_config',
      pageNo: 1,
      size: num,
      total: num
    }
    configQuery(params).then(res => {
      const arr = []
      try {
        searchListInit.forEach(itemFirst => {
          if (itemFirst.key === 'plant' && !isResendFlag) {
            const { records } = res.resultData
            for (let index = 0; index < records.length; index++) {
              const element = records[index]
              arr.push({
                label: element.configValue,
                value: element.configValue
              })
            }
            itemFirst.selectList = arr
          }
          setSearchList([...searchListInit])
        })
      } catch (error) {}
    })
  }

  const getTableList = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}

    let taggingTime = info.taggingDate
    let startTime = taggingTime && taggingTime[0] ? taggingTime[0].format(dateFormat) : null
    let endTime = taggingTime && taggingTime[1] ? taggingTime[1].format(dateFormat) : null
    const params = {
      apiType: props.apiType,
      plantCodeList: info.plant,
      status: info.sendStatus,
      timeStart: startTime ? startTime + ' 00:00:00' : startTime,
      timeEnd: endTime ? endTime + ' 23:59:59' : endTime,
      size: pagination.pageSize,
      pageNo: pagination.currentPage,
      total: pagination.total
    }

    if (isResendFlag) {
      getAPILogListWms(params).then(res => {
        if (res.errorCode === '200') {
          const dt = res.resultData
          lastTableListId.current = dt.firstRowId
          setTableList(dt.records)
          const pg = {
            ...pagination,
            total: dt.total
          }
          setPagination(pg)
        }
      })
    } else {
      getAPILogList(params).then(res => {
        if (res.errorCode === '200') {
          const dt = res.resultData
          lastTableListId.current = dt.firstRowId
          setTableList(dt.records)
          const pg = {
            ...pagination,
            total: dt.total
          }
          setPagination(pg)
        }
      })
    }
  }

  let tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.plant'),
      dataIndex: 'plantCode',
      width: 80
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.status'),
      dataIndex: 'invocationStatus',
      width: 80
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.errorCode'),
      dataIndex: 'errorCode',
      width: 80
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.errorMessage'),
      dataIndex: 'errorMessage',
      width: 180,
      render: text => <div className="word_break_all">{text}</div>
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.payloadStorePath'),
      dataIndex: 'payloadStorePath',
      width: 100,
      render: (text, record) => {
        if (!text) return
        return (
          <div
            style={{ textDecoration: 'underline', cursor: 'pointer', minWidth: 50 }}
            onClick={() => {
              downLoadFun(record.id)
            }}
          >
            {formatMessage(commonStore, 'languageObj.dashboard.download')}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.createTime'),
      dataIndex: 'createTime',
      width: 100,
      render: text => {
        return dateTrans(text, true)
      }
    }
  ]

  if (isResendFlag) {
    tableColumns = [
      {
        title: formatMessage(commonStore, 'languageObj.nfcUIDReport.system'),
        dataIndex: 'plantCode',
        width: 80
      },
      {
        title: formatMessage(commonStore, 'languageObj.dashboard.status'),
        dataIndex: 'invocationStatus',
        width: 80
      },
      {
        title: formatMessage(commonStore, 'languageObj.dashboard.errorCode'),
        dataIndex: 'errorCode',
        width: 80
      },
      {
        title: formatMessage(commonStore, 'languageObj.dashboard.errorMessage'),
        dataIndex: 'errorMessage',
        width: 180,
        render: text => <div className="word_break_all">{text}</div>
      },
      {
        title: formatMessage(commonStore, 'languageObj.dashboard.payloadStorePath'),
        dataIndex: 'payloadStorePath',
        width: 100,
        render: (text, record) => {
          if (!text) return
          return (
            <div
              style={{ textDecoration: 'underline', cursor: 'pointer', minWidth: 50 }}
              onClick={() => {
                downLoadFun(record.id)
              }}
            >
              {formatMessage(commonStore, 'languageObj.dashboard.download')}
            </div>
          )
        }
      },
      {
        title: formatMessage(commonStore, 'languageObj.dashboard.createTime'),
        dataIndex: 'createTime',
        width: 100,
        render: text => {
          return dateTrans(text, true)
        }
      }
    ]
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const downLoadFun = logId => {
    const params = {
      logId
    }
    dashboardPayloadDownload(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  //TODO
  const reSendFun = () => {
    getAPITaskRetry(selectedRowKeys).then(res => {
      // let str = ''
      if (res.errorCode === '200') {
        messageModal('success', {
          content: formatMessage(commonStore, 'languageObj.commonLocale.success')
        })
        setQueryFlag(!queryFlag)
        setSelectedRowKeys([])
      }
      // else if (res.errorCode === '433') {
      //   str = 'languageObj.dashboard.paramEmpty'
      // } else if (res.errorCode === '2100') {
      //   str = 'languageObj.dashboard.apiExist'
      // } else if (res.errorCode === '444') {
      //   str = 'languageObj.dashboard.taskExist'
      // } else if (res.errorCode === '445') {
      //   str = 'languageObj.dashboard.notSupportWms'
      // } else if (res.errorCode === '446') {
      //   str = 'languageObj.dashboard.serverError'
      // }
    })
  }
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const hasResendBtnFlag = (isResendFlag || isResendLastFlag) && hasPermission(menu_nfc_apiDashboard)
  const rowSelection = {
    selectedRowKeys,
    getCheckboxProps: record => {
      // 最后一条是失败的可以resend
      return {
        disabled:
          (isResendFlag || isResendLastFlag) &&
          ((!(lastTableListId.current || []).includes(record.id) && record.invocationStatus === 'FAIL') ||
            record.invocationStatus !== 'FAIL')
      }
    },
    onChange: onSelectChange
  }
  return (
    <div>
      <div className="search-bar">
        <SearchBar ref={formRef} searchList={searchList}>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="right_search"
            style={{ justifyContent: 'flex-end' }}
          >
            <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
              {formatMessage(commonStore, 'languageObj.commonLocale.search')}
            </Button>
            {/* <Button onClick={searchClearDataBtn}>{formatMessage(commonStore, 'languageObj.commonLocale.clear')}</Button> */}
          </Col>
        </SearchBar>
      </div>
      <div className="mb15 mt15" style={{ display: 'flex' }}>
        {hasResendBtnFlag && (
          <Button disabled={selectedRowKeys.length === 0 ? true : false} type="primary" onClick={reSendFun}>
            {formatMessage(commonStore, 'languageObj.commonLocale.resend')}
          </Button>
        )}
      </div>
      <div className="content-container mt15">
        <AntdTable
          rowKey={record => Number(record.id)}
          rowSelection={hasResendBtnFlag ? rowSelection : undefined}
          dataSource={tableList}
          columns={tableColumns}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
}
export default NfcSkuModalTable
